<template>
<div class="chapter">
<div class="inner_page">
<div class="image"><img alt="" src="image/img003.jpg"/></div>
<div class="Basic-Text-FrameB" id="_idContainer005b">
<p class="Basic-Paragraph ParaOverride-2" style="border-bottom: solid black 2px; margin-right: 10%; margin-left: 10%;"><span class="CharOverride-2b"><a id="other"></a>Other <em class="italic">Peanuts</em> AMP! 
Comics for Kids Books</span></p>
<p class="italic">Snoopy: Cowabunga</p>
<p class="italic">Charlie Brown and Friends</p>
<p class="italic">Charlie Brown: Pow!</p>
<p class="italic">Woodstock: Master of Disguise</p>
<p class="italic">Snoopy: Contact!</p>
<p class="italic">Snoopy: Party Animal</p>
<p class="italic">Charlie Brown: Here We Go Again</p>
</div>
<div class="image"><img alt="" src="image/img004.jpg"/></div>
<div class="image"><a id="snoopy"></a><img alt="" src="image/img005.jpg"/></div>
<div class="image"><img alt="" src="image/img006.jpg"/></div>
<div class="image"><img alt="" src="image/img007.jpg"/></div>
<div class="image"><img alt="" src="image/img008.jpg"/></div>
<div class="image"><img alt="" src="image/img009.jpg"/></div>
<div class="image"><img alt="" src="image/img010.jpg"/></div>
<div class="image"><img alt="" src="image/img011.jpg"/></div>
<div class="image"><img alt="" src="image/img012.jpg"/></div>
<div class="image"><img alt="" src="image/img013.jpg"/></div>
<div class="image"><img alt="" src="image/img014.jpg"/></div>
<div class="image"><img alt="" src="image/img015.jpg"/></div>
<div class="image"><img alt="" src="image/img016.jpg"/></div>
<div class="image"><img alt="" src="image/img017.jpg"/></div>
<div class="image"><img alt="" src="image/img018.jpg"/></div>
<div class="image"><img alt="" src="image/img019.jpg"/></div>
<div class="image"><img alt="" src="image/img020.jpg"/></div>
<div class="image"><img alt="" src="image/img021.jpg"/></div>
<div class="image"><img alt="" src="image/img022.jpg"/></div>
<div class="image"><img alt="" src="image/img023.jpg"/></div>
<div class="image"><img alt="" src="image/img024.jpg"/></div>
<div class="image"><img alt="" src="image/img025.jpg"/></div>
<div class="image"><img alt="" src="image/img026.jpg"/></div>
<div class="image"><img alt="" src="image/img027.jpg"/></div>
<div class="image"><img alt="" src="image/img028.jpg"/></div>
<div class="image"><img alt="" src="image/img029.jpg"/></div>
<div class="image"><img alt="" src="image/img030.jpg"/></div>
<div class="image"><img alt="" src="image/img031.jpg"/></div>
<div class="image"><img alt="" src="image/img032.jpg"/></div>
<div class="image"><img alt="" src="image/img033.jpg"/></div>
<div class="image"><img alt="" src="image/img034.jpg"/></div>
<div class="image"><img alt="" src="image/img035.jpg"/></div>
<div class="image"><img alt="" src="image/img036.jpg"/></div>
<div class="image"><img alt="" src="image/img037.jpg"/></div>
<div class="image"><img alt="" src="image/img038.jpg"/></div>
<div class="image"><img alt="" src="image/img039.jpg"/></div>
<div class="image"><img alt="" src="image/img040.jpg"/></div>
<div class="image"><img alt="" src="image/img041.jpg"/></div>
<div class="image"><img alt="" src="image/img042.jpg"/></div>
<div class="image"><img alt="" src="image/img043.jpg"/></div>
<div class="image"><img alt="" src="image/img044.jpg"/></div>
<div class="image"><img alt="" src="image/img045.jpg"/></div>
<div class="image"><img alt="" src="image/img046.jpg"/></div>
<div class="image"><img alt="" src="image/img047.jpg"/></div>
<div class="image"><img alt="" src="image/img048.jpg"/></div>
<div class="image"><img alt="" src="image/img049.jpg"/></div>
<div class="image"><img alt="" src="image/img050.jpg"/></div>
<div class="image"><img alt="" src="image/img051.jpg"/></div>
<div class="image"><img alt="" src="image/img052.jpg"/></div>
<div class="image"><img alt="" src="image/img053.jpg"/></div>
<div class="image"><img alt="" src="image/img054.jpg"/></div>
<div class="image"><img alt="" src="image/img055.jpg"/></div>
<div class="image"><img alt="" src="image/img056.jpg"/></div>
<div class="image"><img alt="" src="image/img057.jpg"/></div>
<div class="image"><img alt="" src="image/img058.jpg"/></div>
<div class="image"><img alt="" src="image/img059.jpg"/></div>
<div class="image"><img alt="" src="image/img060.jpg"/></div>
<div class="image"><img alt="" src="image/img061.jpg"/></div>
<div class="image"><img alt="" src="image/img062.jpg"/></div>
<div class="image"><img alt="" src="image/img063.jpg"/></div>
<div class="image"><img alt="" src="image/img064.jpg"/></div>
<div class="image"><img alt="" src="image/img065.jpg"/></div>
<div class="image"><img alt="" src="image/img066.jpg"/></div>
<div class="image"><img alt="" src="image/img067.jpg"/></div>
<div class="image"><img alt="" src="image/img068.jpg"/></div>
<div class="image"><img alt="" src="image/img069.jpg"/></div>
<div class="image"><img alt="" src="image/img070.jpg"/></div>
<div class="image"><img alt="" src="image/img071.jpg"/></div>
<div class="image"><img alt="" src="image/img072.jpg"/></div>
<div class="image"><img alt="" src="image/img073.jpg"/></div>
<div class="image"><img alt="" src="image/img074.jpg"/></div>
<div class="image"><img alt="" src="image/img075.jpg"/></div>
<div class="image"><img alt="" src="image/img076.jpg"/></div>
<div class="image"><img alt="" src="image/img077.jpg"/></div>
<div class="image"><img alt="" src="image/img078.jpg"/></div>
<div class="image"><img alt="" src="image/img079.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch1.vue?a24f49fc